import { render, staticRenderFns } from "./BundleItemInput.vue?vue&type=template&id=2ca48242&scoped=true&"
import script from "./BundleItemInput.vue?vue&type=script&lang=js&"
export * from "./BundleItemInput.vue?vue&type=script&lang=js&"
import style0 from "./BundleItemInput.vue?vue&type=style&index=0&id=2ca48242&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca48242",
  null
  
)

export default component.exports